import {ChangeDetectionStrategy, ChangeDetectorRef, Component} from "@angular/core";
import {BaseBadgeDirective} from "../../../shared";


@Component({
  selector: 'int-badge, [intBadge]',
  template: `<ng-content></ng-content>`,
  styleUrls: [
    '../../../shared/base-badge/base-badge.scss',
    './int-badge.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntBadgeComponent extends BaseBadgeDirective {

  constructor(
    protected readonly cdr: ChangeDetectorRef
  ) {
    super(cdr)
  }
}
